<template>
    <form v-if="copy" class="is-clearfix">
        <h1 class="title is-3">Settings</h1>

        <div class="columns">
            <div class="column">
                <o-field label="First Name" :type="fieldType('first_name')" :message="getError('first_name')">
                    <o-input v-model="copy.first_name"/>
                </o-field>

                <o-field label="Last Name" :type="fieldType('last_name')" :message="getError('last_name')">
                    <o-input v-model="copy.last_name"/>
                </o-field>

                <o-field label="Email" :type="fieldType('email')" :message="getError('email')">
                    <o-input type="email"
                             v-model="copy.email"
                             placeholder="company@example.com"
                    />
                </o-field>

                <o-field label="Mobile" :type="fieldType('mobile')" :message="getError('mobile')">
                    <o-input v-model="copy.mobile"/>
                </o-field>

                <o-field label="Phone Extension" :type="fieldType('phone_extension')"
                         :message="getError('phone_extension')">
                    <o-input v-model="copy.phone_extension"/>
                </o-field>

                <img v-if="copy.avatar_url" :src="copy.avatar_url" class="signature">
                <o-field label="Avatar">
                    <uploadcare
                            v-model="copy.avatar_url"
                            :do-not-store="true"
                            :only-images="true"
                            :clearable="true"
                            format="url"
                            ref="ucare"
                            crop="1:1"
                    />
                </o-field>

                <img v-if="copy.signature" :src="copy.signature" class="signature">
                <o-field label="Signature">
                    <uploadcare
                            v-model="copy.signature"
                            :do-not-store="true"
                            :only-images="true"
                            :clearable="true"
                            format="url"
                            ref="ucare"
                    />
                </o-field>
            </div>

            <div class="column">
                <o-field label="Password" :type="fieldType('password')" :message="getError('password')">
                    <o-input v-model="copy.password" type="password" password-reveal :class="'reveal-external'" />
                </o-field>

                <o-field label="Password confirmation" :type="fieldType('password_confirmation')"
                         :message="getError('password_confirmation')">
                    <o-input v-model="copy.password_confirmation" type="password" password-reveal :class="'reveal-external'" ></o-input>
                </o-field>

                <o-field label="About" :type="fieldType('about')" :message="getError('about')">
                    <o-input maxlength="1000" v-model="copy.about" type="textarea"></o-input>
                </o-field>
                <o-field label="Follow Frequency" :type="fieldType('followed_frequency')" :message="getError('followed_frequency')">
                    <o-select v-model="copy.followed_frequency" >
                        <option value="daily">Daily</option>
                        <option value="weekly">Weekly</option>
                        <option value="monthly">Monthly</option>
                    </o-select>
                </o-field>
            </div>
        </div>

        <div class="field is-grouped is-pulled-right">
            <p class="control">
                <button type="reset" class="button" exact @click.prevent="setup">Reset</button>
            </p>
            <p class="control">
                <button @click.prevent="handleUpdate" v-submit="submitting" class="button is-success">Save</button>
            </p>
        </div>
    </form>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import Uploadcare from '../components/Uploadcare'
    import HandlesForm from './../mixins/HandlesForm'

    export default {
        mixins: [HandlesForm],

        components: {
            Uploadcare
        },

        computed: {
            ...mapGetters(['currentUser'])
        },

        created() {
            this.setup()
        },

        methods: {
            ...mapActions({
                simpleUpdateUser: 'simpleUpdateUser',
                createFile: 'createFile'
            }),

            setup() {
                let copy = _.clone(this.currentUser)

                copy.avatar_url = copy.avatar_url.includes('ucarecdn') ? copy.avatar_url : ''

                copy.password = ''
                copy.password_confirmation = ''

                this.copy = copy

            },

            handleUpdate() {
                let submit = this.wrapSubmit(this.simpleUpdateUser)
                submit(this.copy)
                    .then(res => {
                        this.setup()
                        this.successMessage('Your profile has been updated')
                        return res
                    })
            }
        }
    }
</script>
